export function OutlineSaveIcon({
  width = 24,
  height = 24,
  fill = 'none',
  stroke = 'currentColor',
  strokeWidth = 2,
}: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.95435 3H15.9559V7.09919C15.9559 7.59359 15.5527 7.99679 15.0583 7.99679H8.85674C8.36234 7.99679 7.95915 7.59359 7.95915 7.09919V3H7.95435Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
      />
      <path
        d="M18.956 21H4.94968C3.84568 21 2.95288 20.1072 2.95288 19.0032V4.9968C2.95288 3.8928 3.84568 3 4.94968 3H17.1273C17.6553 3 18.1641 3.2112 18.5385 3.5856L20.3672 5.4144C20.7416 5.78879 20.9528 6.29759 20.9528 6.82559V19.0032C20.9528 20.1072 20.06 21 18.956 21Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16.9498 12.998H6.95142V20.9996H16.9498V12.998Z"
        stroke={stroke}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
